import { queryOptions } from '@tanstack/react-query'
import { Address } from 'viem'

import * as hl from '@nktkas/hyperliquid'
import { isTestnet } from '@/config/consts'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'

const transport = new hl.HttpTransport({ isTestnet })
const publicClient = new hl.PublicClient({ transport })
interface L1BalancesParams {
  account?: Address
}

export type L1Balances = Awaited<ReturnType<typeof publicClient.spotClearinghouseState>>['balances']

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function l1BalancesQueryOptions({ account }: L1BalancesParams) {
  return queryOptions<L1Balances>({
    queryKey: l1BalancesQueryKey({ account }),
    queryFn: async () => {
      if (!account) {
        return []
      }

      try {
        const { balances } = await publicClient.spotClearinghouseState({
          user: account,
        })

        // @TODO: filter out unsupported tokens?
        return balances.map((balance) => ({
          ...balance,
          total: NormalizedUnitNumber(balance.total).minus(NormalizedUnitNumber(balance.hold)).toString(),
        }))
      } catch (error) {
        console.error(error)
        return []
      }
    },
  })
}

export interface L1BalancesQueryKeyParams {
  account: Address | undefined
}

export function l1BalancesQueryKey({ account }: L1BalancesQueryKeyParams): unknown[] {
  return [...getL1BalancesQueryKeyPrefix({ account })]
}

function getL1BalancesQueryKeyPrefix({ account }: L1BalancesQueryKeyParams): unknown[] {
  return ['l1-balances', account]
}
